import { jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useMemo } from 'react';
import { ScrollGroupContext } from './context.mjs';
"use strict";
function ScrollGroup({
  children,
  onScrollItem,
  onAddItem,
  onResizeItem
}) {
  const scrollGroupItemsRef = useRef([]);
  const currentManualScrollMetaRef = useRef(null);
  const registerItem = useCallback(item => {
    scrollGroupItemsRef.current.push(item);
    return () => {
      scrollGroupItemsRef.current = scrollGroupItemsRef.current.filter(existingItem => existingItem !== item);
    };
  }, []);
  const contextValue = useMemo(() => ({
    registerItem,
    scrollGroupItemsRef,
    currentManualScrollMetaRef,
    onScrollItem,
    onAddItem,
    onResizeItem
  }), [onScrollItem, registerItem, onAddItem, onResizeItem]);
  return /* @__PURE__ */jsx(ScrollGroupContext.Provider, {
    value: contextValue,
    children
  });
}
export { ScrollGroup };
//# sourceMappingURL=ScrollGroup.mjs.map
